import {useMemo} from 'react'

import {
  type ColumnWarningKind,
  getColumnWarning,
  getColumnWarnings,
  getImportedIssueFields,
} from '../helpers/get-column-warning'
import type {ColumnModel} from '../models/column-model'
import {useAllColumns} from '../state-providers/columns/use-all-columns'

export function useColumnWarning(column: ColumnModel | undefined): ColumnWarningKind | undefined {
  const {allColumns} = useAllColumns()

  return useMemo(() => {
    if (!column || !allColumns) return undefined
    const issueFieldNames = getImportedIssueFields(allColumns)
    return getColumnWarning(column, issueFieldNames)
  }, [column, allColumns])
}

export function useColumnWarnings(columns: Array<ColumnModel>): Map<string | number, ColumnWarningKind> {
  const {allColumns} = useAllColumns()

  return useMemo(() => {
    if (!allColumns) return new Map<string | number, ColumnWarningKind>()
    return getColumnWarnings(columns, allColumns)
  }, [columns, allColumns])
}
